import { css } from 'lit'

export const style = css`
  :host {
    display: block;
    max-inline-size: 768px;
    overflow-wrap: anywhere;
  }
`
